import { Component, OnInit } from '@angular/core';
import { CommonService } from '@app/shared/services/common/common.service';

@Component({
  selector: 'app-aboutus',
  templateUrl: './aboutus.component.html',
  styleUrls: ['./aboutus.component.css']
})
export class AboutusComponent implements OnInit {

  about: any;
  constructor(private commonservice: CommonService) { }

  ngOnInit() {
    this.fn_GetAboutStore();
  }

  fn_GetAboutStore() {
    this.commonservice.getAboutStoreDetails(localStorage.getItem('storeId')).subscribe((res: any) => {
        this.about = res.Data.ResponseData !== null ? res.Data.ResponseData : '';
    }, (err: any) => {

    });
  }
}
